"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var LogLevel_1 = require("./LogLevel");
/**
 * ConsoleLogger writes logs with console
 *
 * ```typescript
 *   // working with the ConsoleLogger
 *   const logger = new ConsoleLogger('demo'); //default level is LogLevel.WARN
 *   logger.info('info');
 *   logger.debug('debug');
 *   logger.warn('warn');
 *   logger.error('error');
 *
 *   // setting logging levels
 *   const logger = new ConsoleLogger('demo', LogLevel.INFO)
 *   logger.debug(debugFunc()); // this will not show up
 *   logger.setLogLevel(LogLevel.DEBUG)
 *   logger.debug(debugFunc()); // this will show up
 *
 * ```
 */


var ConsoleLogger = /*#__PURE__*/function () {
  function ConsoleLogger(name) {
    var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : LogLevel_1.default.WARN;

    _classCallCheck(this, ConsoleLogger);

    this.name = name;
    this.level = level;
  }

  _createClass(ConsoleLogger, [{
    key: "info",
    value: function info(msg) {
      this.log(LogLevel_1.default.INFO, msg);
    }
  }, {
    key: "warn",
    value: function warn(msg) {
      this.log(LogLevel_1.default.WARN, msg);
    }
  }, {
    key: "error",
    value: function error(msg) {
      this.log(LogLevel_1.default.ERROR, msg);
    }
  }, {
    key: "debug",
    value: function debug(debugFunction) {
      if (LogLevel_1.default.DEBUG < this.level) {
        return;
      }

      if (typeof debugFunction === 'string') {
        this.log(LogLevel_1.default.DEBUG, debugFunction);
      } else if (debugFunction) {
        this.log(LogLevel_1.default.DEBUG, debugFunction());
      } else {
        this.log(LogLevel_1.default.DEBUG, '' + debugFunction);
      }
    }
  }, {
    key: "setLogLevel",
    value: function setLogLevel(level) {
      this.level = level;
    }
  }, {
    key: "getLogLevel",
    value: function getLogLevel() {
      return this.level;
    }
  }, {
    key: "log",
    value: function log(type, msg) {
      if (type < this.level) {
        return;
      }

      var timestamp = new Date().toISOString();
      var logMessage = "".concat(timestamp, " [").concat(LogLevel_1.default[type], "] ").concat(this.name, " - ").concat(msg);

      switch (type) {
        case LogLevel_1.default.ERROR:
          console.error(logMessage);
          break;

        case LogLevel_1.default.WARN:
          console.warn(logMessage);
          break;

        case LogLevel_1.default.DEBUG:
          console.debug(logMessage.replace(/\\r\\n/g, '\n'));
          break;

        case LogLevel_1.default.INFO:
          console.info(logMessage);
          break;
      }
    }
  }]);

  return ConsoleLogger;
}();

exports.default = ConsoleLogger;